export default __webpack_public_path__ + "static/media/DISPATCH_LOAD.3194fd61.svg";